export default "__VITE_ASSET__e84f4b19__"